/** ==================
 *  Gemba Walks module
 *  ==================
 */

// TODO: Move existing GW actions and mutations to this module

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
